import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import CustomButton from "../../Common/CustomButton";
import Uploader from "../../Common/Uploader";
import FilesModalSelector from "../../Files/FilesModalSelector";
import "../../Lists/Lists.css";

// Edits a section's `carousel` media field, same look as the old list carousel.
// Changes are local until the section's "Save" button is clicked.
const CarouselInput = ({ images, setImages }) => {
  const [showModal, setshowModal] = useState(false);

  const toggleImage = (img) =>
    setImages((prev) =>
      prev.some((el) => el.id === img.id)
        ? prev.filter((el) => el.id !== img.id)
        : [...prev, img]
    );

  const replaceImage = (index) => (img) =>
    setImages((prev) => prev.map((el, i) => (i === index ? img : el)));

  const removeImage = (index) =>
    setImages((prev) => prev.filter((_, i) => i !== index));

  return (
    <div className="mt-5 row justify-content-center">
      <div className="text-orange mb-0 f20 text-start">Edit Carousel Images</div>
      <div className="mb-0 f16 fw-bold text-start">
        Contains {images.length} image(s), click "Save" to apply your changes
      </div>
      <div
        className="AddToCarousel mb-4 bold f24 text-grey col-4"
        onClick={() => setshowModal(true)}
      >
        <i className="bi f48 bi-plus-square-fill iconPlus"></i>
        Add images to the carousel
      </div>

      {images.length > 0 && (
        <Splide options={{ perPage: 1, perMove: 1 }}>
          {images.map((img, index) => (
            <SplideSlide className="container-fluid" key={`${img.id}-${index}`}>
              <div className="col-12 row justify-content-center mb-4">
                <div className="col-5">
                  <Uploader
                    image={img}
                    handleImage={replaceImage(index)}
                    labelinput={`Image ${index + 1} / ${images.length}`}
                  />
                </div>
              </div>
              <div className="row justify-content-center buttonsCustomPadding">
                <div className="col-5">
                  <CustomButton
                    buttonText="Remove from carousel"
                    type="red"
                    iconStart="trash-fill"
                    callBack={() => removeImage(index)}
                  />
                </div>
              </div>
            </SplideSlide>
          ))}
        </Splide>
      )}

      <Modal
        show={showModal}
        size={"xl"}
        onHide={() => setshowModal(false)}
        className="myModal"
      >
        <Modal.Header>
          <div className="container-fluid">
            <div className="row">
              <div className="col-9">
                Select images ({images.length} selected): click an image to add
                or remove it
              </div>
              <div className="col-3">
                <CustomButton
                  buttonText={"Done"}
                  callBack={() => setshowModal(false)}
                />
              </div>
            </div>
          </div>
        </Modal.Header>
        <FilesModalSelector
          handleImage={toggleImage}
          selectedIds={images.map((img) => img.id)}
        />
      </Modal>
    </div>
  );
};

export default CarouselInput;
